import { styled } from '@/stitches.config';
import { Box, Button } from '@base-app';

export const StyledButton = styled(Button, {
  width: '130px',
});

export const StyledButtonContainer = styled(Box, {
  display: 'flex',
  justifyContent: 'center',
  margin: '$4 0 $6 0',
});

export const StyledTitle = styled(Box, {
  color: '$charcoal300',
  fontSize: '$md',
  fontWeight: '$bold',
  lineHeight: '$4',
});

export const StyledNote = styled(Box, {
  color: '$charcoal300',
  fontSize: '$md',
  fontWeight: '$normal',
  lineHeight: '$6',
});

export const StyledContent = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
  marginBottom: '$8',
});

export const StyledDate = styled(Box, {
  color: '$darkBlue300',
  fontSize: '$lg',
  fontWeight: '$medium',
  lineHeight: '$6',
});
